/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntegrationChannel } from 'app/shared/model/integration-channel.model';
import { ITenantIntegrationChannel } from 'app/shared/model/tenant-integration-channel.model';

export interface IDataCategory {
  id?: string;
  active?: boolean;
  name?: string | null;
  description?: string | null;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  cursor?: number;
  integrationChannels?: IIntegrationChannel[] | null;
  tenantIntegrationChannels?: ITenantIntegrationChannel[] | null;
}

export const defaultValue: Readonly<IDataCategory> = {
  active: false,
};
